import React, { useState, useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import "../../admin_tools.css";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import BackIcon from "../../../../assets/communication/Back.svg";
import { ADMIN_TOOLS_CATEGORY_LIST } from "../../../../routes";
import EditIcon from "../../../../assets/common/edit_icon.svg";
import ArrorRightIcon from "../../../../assets/common/arrao-right.svg";
import { fetchCategoryById } from "../../../../store/category";
import { Loader } from "@progress/kendo-react-indicators";
import { CategoryForm } from "./category_form";
import { updateCategory } from "../../../../store/category";
import { fetchAllSenders,fetchAllApprovers } from "../../../../store/categoryUserList";

export const CategoryDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const category_id = query.get("id");
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorTxt, setErrorTxt] = useState("");
  const [filteredData,setFilteredData] = useState({});
  const {
    category_data,
    data_loading,
    data_error,
    update_data,
    update_error,
    update_loading,
  } = useSelector((state) => state.category);
  const { approvers_loading, approvers, approvers_error,senders_loading, senders, senders_error } = useSelector(
      (state) => state.categoryUserList
    );
  useEffect(() => {
    if (category_id) {
      dispatch(fetchCategoryById(category_id));
      dispatch(fetchAllSenders());
      dispatch(fetchAllApprovers());
    }
  }, []);
  useEffect(()=>{
    if(category_data){
      const inactive_senders = senders.filter((x)=>x?.is_active == false).map((x)=>x?.username);
      const inactive_approvers = approvers.filter(x=>x?.is_active == false).map(x=> x?.username);
      const sender_user_list = category_data?.sender_user_list?.filter(x=> !(inactive_senders.includes(x?.username)));
      const approver_user_list = category_data?.approver_user_list?.filter(x=> !(inactive_approvers.includes(x?.username)));
      setFilteredData({...category_data,sender_user_list,approver_user_list});
    }
  },[category_data,approvers,senders])
  const handleSaveCategory = (data) => {
    data.id = category_id;
    dispatch(updateCategory({ data, category_id })).then((response) => {
      console.log("handleSaveCategory response:", response);
      if (response.error && response.error.message) {
        setErrorTxt(response.payload || response.error.message);
        setShowErrorDialog(true);
      } else {
        setIsEdit(false);
        dispatch(fetchCategoryById(category_id));
      }
    });
  };
  return (
    <>
      {showErrorDialog && (
        <Dialog
          className="category-details-alert-form"
          title={"Alert"}
          onClose={() => setShowErrorDialog(false)}
        >
          <p
            style={{
              margin: "25px",
              textAlign: "center",
            }}
          >
            {errorTxt}
          </p>
        </Dialog>
      )}
      <div className="detail-body">
        {data_loading || loading || update_loading ? (
          <Loader
            type="infinite-spinner"
            style={{
              display: "flex",
              alignItems: "center",
              width: "40px",
              margin: "auto",
              justifyContent: "center",
              height: "100vh",
            }}
          />
        ) : (
          <>
            <div className="detail-header">
              <div
                className="categoryback-group-div"
                onClick={() => navigate(ADMIN_TOOLS_CATEGORY_LIST)}
              >
                <img src={BackIcon} className="categoryback-icon" />
                <span className="categoryback-label">Back</span>
              </div>
              {!isEdit && (
                <div>
                  <Button className="editBtn" onClick={() => setIsEdit(true)}>
                    <img src={EditIcon} style={{ verticalAlign: "middle" }} />
                    <span className="editBtn-label">Edit</span>
                    <img
                      src={ArrorRightIcon}
                      style={{ verticalAlign: "middle" }}
                    />
                  </Button>
                </div>
              )}
            </div>
            <div className="detail-content">
              <CategoryForm
                data={filteredData}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                setLoading={setLoading}
                submitForm={handleSaveCategory}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};
